<template>
  <div class="posts">
    <v-container grid-list-sm>
      <v-layout row wrap>
        <v-flex sm4 v-if="posts && posts.length > 0 && hasPostsInCategoryAndLanguage($route.params.cid, lang)" class="sum-fixed__wrapper">
          <div class="sum-fixed-posts">
            <div v-for="post in posts" :key="post.id">
              <div v-if="$route.params.cid && ((lang === 'de' && post.post_language !== 'en') || (lang === 'en' && post.post_language === 'en'))"
                :id="'sum_' + post.id" :class="getActiveClass(post.id)">
                <div class="sum-type-section">{{ translate['Beitrag'][lang] }}</div>
                <a :href="'/posts/' + $route.params.cid + '/' + post.id" v-html="post.title.rendered" class="lnk_nostyle"
                  v-on:click="setCurrentPost(post.id, $event)"></a>
              </div>
            </div>
          </div>
        </v-flex>
        <v-flex sm4 v-else-if="posts && posts.length > 0 && !hasPostsInCategoryAndLanguage($route.params.cid, lang)" class="progress-wrapper">
          <div class="col-inner col-highlight">
            <p id="g-main-content-title">{{ translate['no_posts_in_category_and_language'][lang] }}</p>
          </div>
        </v-flex>
        <v-flex sm4 class="progress-wrapper" v-else>
          <v-progress-circular indeterminate size="64" color="mari"></v-progress-circular>
        </v-flex>
        <template v-if="currentPost">
          <v-flex sm7>
            <div class="col-inner col-highlight">
              <h1 id="g-main-content-title" v-html="currentPost.title.rendered"></h1>
              <div class="ffs" v-html="currentPost.content.rendered"></div>
            </div>
          </v-flex>
        </template>
        <template v-else-if="getFirstPostInCategoryAndLanguage($route.params.cid, lang)">
          <v-flex sm7>
            <div class="col-inner col-highlight">
              <h1 id="g-main-content-title" v-html="getFirstPostInCategoryAndLanguage($route.params.cid, lang).title.rendered"></h1>
              <div class="ffs" v-html="getFirstPostInCategoryAndLanguage($route.params.cid, lang).content.rendered"></div>
            </div>
          </v-flex>
        </template>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Posts',
  data () {
    return {
      msg: 'Posts',
      cssClass: this.$options.name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase(),
      loading: true,
      currentPost: null,
      sum: null,
      isScrolling: null,
      scrollHasListener: false
      // firstPost: null
    }
  },
  created () {
    if (this.posts.length === 0) {
      // console.log('getPostsByCategoryId', this.$route.params.cid)
      if (this.$route.params.cid) {
        this.getPostsByCategoryId(this.$route.params.cid)
      } else {
        // this.getPosts()
        // console.log('nothing to get')
      }
    }
  },
  mounted () {
    if (this.posts.length > 0) {
      // this.loading = false
      if (this.$route.params.pid) {
        this.setCurrentPost(Number(this.$route.params.pid))
      }
      this.sum = document.querySelector('.sum-fixed-posts')
      this.addScrollListener()
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll, false)
  },
  watch: {
    posts: function () {
      if (this.posts.length > 0 && this.$route.params.pid) {
        this.setCurrentPost(Number(this.$route.params.pid))
      }
      if (this.posts.length > 0) {
        this.sum = document.querySelector('.sum-fixed-posts')
        this.addScrollListener()
      }
    },
    '$route' (to, from) {
      // Handle category change
      if (to.params.cid !== from.params.cid) {
        if (to.params.cid) {
          this.getPostsByCategoryId(to.params.cid)
        } else {
          // this.getPosts()
        }
        this.setCurrentPost(null)
      }
      // Handle post selection
      if (to.params.pid) {
        this.setCurrentPost(Number(to.params.pid))
      }
    }
  },
  methods: {
    ...mapActions(['getPostsByCategoryId']),
    setCurrentPost (id, event) {
      if (event) {
        event.preventDefault()
      }
      this.currentPost = null
      this.posts.forEach(post => {
        if (post.id === id) {
          this.currentPost = post
          if (Number(this.$route.params.pid) !== id) {
            this.$router.push({ name: 'Post', params: { cid: this.$route.params.cid, pid: id } })
          }
        }
      })
      // console.log('currentPost', this.currentPost)
      let alle = document.getElementsByClassName('sum')
      for (var i = 0; i < alle.length; i++) {
        alle[i].classList.remove('sum-active')
      }
      let callerElement = document.getElementById('sum_' + id)
      if (callerElement) {
        callerElement.classList.add('sum-active')
      }
      let el = document.getElementById('g-main-content-title')
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      }
    },
    getActiveClass (id) {
      if (this.$route.params.pid) {
        if (Number(this.$route.params.pid) === id) {
          return 'col-inner col-highlight sum sum-active'
        } else {
          return 'col-inner col-highlight sum'
        }
      } else {
        const firstPost = this.getFirstPostInCategoryAndLanguage(this.$route.params.cid, this.lang)
        if (firstPost && firstPost.id === id) {
          return 'col-inner col-highlight sum sum-active'
        } else {
          return 'col-inner col-highlight sum'
        }
      }
    },
    onScroll (event) {
      let sum = this.sum
      window.clearTimeout(this.isScrolling)
      this.isScrolling = setTimeout(function () {
        let windowWidth = window.innerWidth ||
          document.documentElement.clientWidth ||
          document.getElementsByTagName('body')[0].clientWidth
        let windowHeight = window.innerHeight ||
          document.documentElement.clientHeight ||
          document.getElementsByTagName('body')[0].clientHeight
        if (windowWidth >= 600) {
          let offset = document.documentElement.scrollTop
          if (offset > 48 && sum.offsetHeight < windowHeight) {
            sum.style.top = (offset) + 'px'
          } else {
            sum.style.top = '0'
          }
        } else {
          sum.style.top = '0'
        }
      }, 60)
    },
    addScrollListener () {
      if (!this.scrollHasListener) {
        window.addEventListener('scroll', this.onScroll, false)
        this.scrollHasListener = true
      }
    },
    isPostInLanguage (post, language) {
      return (language === 'de' && post.post_language !== 'en') || (language === 'en' && post.post_language === 'en')
    },
    hasPostsInCategoryAndLanguage (categoryId, language) {
      return this.posts.some(post => post.categories.includes(Number(categoryId)) && this.isPostInLanguage(post, language))
    },
    getFirstPostInCategoryAndLanguage (categoryId, language) {
      return this.posts.find(post => post.categories.includes(Number(categoryId)) && this.isPostInLanguage(post, language))
    }

  },
  computed: {
    ...mapGetters([
      'posts',
      'translate',
      'lang'
    ])
  }
}
</script>
<style lang="scss">
.lnk_nostyle {
  text-decoration: none;
}

.sum-fixed-posts {
  position: relative;
  transition: all 0.5s;
}

.progress-wrapper {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Posts.vue